import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface User {
  email: string;
  role: string;
  firstName: string | null;
  lastName: string | null;
  token: string;
  refreshToken: string;
  companyId: number | null;
}

interface UserState {
  user: User | null;
  isInitialized: boolean;
}

// Load user from localStorage on initialization
const loadUserFromStorage = (): User | null => {
  try {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      // Check if token is still valid (not expired)
      if (user.token) {
        return user;
      }
    }
  } catch (error) {
    console.error('Error loading user from localStorage:', error);
  }
  return null;
};

const initialState: UserState = {
  user: loadUserFromStorage(),
  isInitialized: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser(
      state,
      action: PayloadAction<{
        email: string;
        role: string;
        firstName: string | null;
        lastName: string | null;
        token: string;
        refreshToken: string;
        companyId: number | null;
      }>,
    ) {
      console.log('action.payload', action.payload);
      state.user = action.payload;
      // Save to localStorage
      localStorage.setItem('user', JSON.stringify(action.payload));
    },
    clearUser(state) {
      state.user = null;
      // Remove from localStorage
      localStorage.removeItem('user');
    },
    setInitialized(state) {
      state.isInitialized = true;
    },
  },
});

export const { setUser, clearUser, setInitialized } = userSlice.actions;
export default userSlice.reducer;

